__turbopack_context__.v({
  "btnCustom": "home-module-scss-module__C1V1gG__btnCustom",
  "button": "home-module-scss-module__C1V1gG__button",
  "headingSectionOne": "home-module-scss-module__C1V1gG__headingSectionOne",
  "headingSectionThree": "home-module-scss-module__C1V1gG__headingSectionThree",
  "headingSectionThree__TextContainer": "home-module-scss-module__C1V1gG__headingSectionThree__TextContainer",
  "headingSectionTwo": "home-module-scss-module__C1V1gG__headingSectionTwo",
  "homePageLandingBrand": "home-module-scss-module__C1V1gG__homePageLandingBrand",
  "homePageLandingBrand__content": "home-module-scss-module__C1V1gG__homePageLandingBrand__content",
  "homePageLandingBrand__video": "home-module-scss-module__C1V1gG__homePageLandingBrand__video",
});
